export class notAvailableService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    getUnavailables() {
        const action = "getUnavailables";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    setUnavailable(unavailableID) {
        if (this.SingletonSharedData.isNotReadyAvailable(unavailableID)) {
            const message = {
                client: "integration",
                unavailableID: unavailableID,
                action: "setUnavailable"
            }
            this.SingletonWebSocket.send(message);
        } else {
            const error = { code: 406, message: "Unavailable not available: Not found or no number of events." }
            onError(error);
        }
    }
    getUnavailableHistory() {
        const action = "getUnavailableHistory";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/notAvailableService.js